import LoadingAnalysis from "@/components/portfolio/LoadingAnalysis";

const LoadingOther = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-full max-w-md rounded-3xl bg-white shadow-lg p-6">
        <div className="home__container_login">
          <LoadingAnalysis isLoading={true} />
        </div>
      </div>
    </div>
  );
};

export default LoadingOther;
